import { AwsRum, AwsRumConfig } from 'aws-rum-web'
import { devLog } from './devLog'

export const configureAwsRum = (): AwsRum | undefined => {
  const endpoint = import.meta.env.AWS_RUM_ENDPOINT
  const region = import.meta.env.AWS_RUM_REGION

  let guestRoleArn: string
  let identityPoolId: string
  let applicationId: string

  guestRoleArn = import.meta.env.AWS_RUM_ROLE_ARN || ''
  identityPoolId = import.meta.env.AWS_RUM_IDENTITY_POOL_ID || ''
  applicationId = import.meta.env.AWS_RUM_APPLICATION_ID || ''

  if (!guestRoleArn || !identityPoolId || !endpoint || !applicationId || !region) {
    devLog('Unable to configure AWS RUM')
    devLog('guestRoleArn', guestRoleArn)
    devLog('identityPoolId', identityPoolId)
    devLog('endpoint', endpoint)
    devLog('applicationId', applicationId)
    devLog('region', region)
    return undefined
  }

  let awsRum: AwsRum | undefined

  try {
    const config: AwsRumConfig = {
      sessionSampleRate: 1,
      guestRoleArn,
      identityPoolId,
      endpoint,
      telemetries: [
        'performance',
        'errors',
        [
          'http',
          {
            // The http telemetry records the full request URL of every failing
            // request, which would leak the GoCardless session token on a 401.
            // Exclude only the requests that carry it; the cookie-only calls to
            // the same endpoints stay monitored. The two AWS patterns are the
            // plugin defaults, repeated here because this list replaces them.
            urlsToExclude: [
              /cognito-identity\.([^.]*\.)?amazonaws\.com/,
              /sts\.([^.]*\.)?amazonaws\.com/,
              /[?&]sessionToken=/,
            ],
          },
        ],
      ],
      allowCookies: false,
      enableXRay: false,
    }

    const APPLICATION_VERSION: string = '1.0.0'

    awsRum = new AwsRum(applicationId, APPLICATION_VERSION, region, config)
  } catch (error) {
    devLog('RUM error')
    devLog(error)
  }

  return awsRum
}
